import indexPage from './indexPage';

function showLoading($button) {
	indexPage.allowSubmit = false;
	$button.addClass('disabled loading').attr('aria-busy', true);
}

export default showLoading;
